/* =============================================================================
 * [OS-LEGADO-CONGELADO] ARQUIVO TEMPORARIO - APAGAR APOS VALIDACAO
 * =============================================================================
 * Copia CONGELADA do modulo antigo de "OS para coleta" (versao que estava em
 * producao antes da entrada do modulo novo).
 *
 * Origem desta copia: src/Components/CustomUi/loading/styled.ts
 * Papel: componente compartilhado congelado
 *
 * POR QUE ISSO EXISTE
 *   O modulo novo de OS substituiu o antigo. Esta copia fica disponivel por
 *   ~1 SEMANA como plano de contingencia: se o modulo novo apresentar
 *   problema, o time volta a usar esta versao sem interromper o trabalho.
 *
 * NAO EDITE ESTE ARQUIVO
 *   Ele e um retrato fiel do comportamento antigo. Qualquer correcao deve ser
 *   feita no modulo NOVO. Editar aqui destroi o valor da copia.
 *
 * COMO APAGAR (quando o modulo novo for validado)
 *   1. Remover a pasta inteira: src/Views/app/precisao/OSAntigaLegado/
 *   2. Remover a rota/menu marcado com [OS-LEGADO-CONGELADO] em
 *      src/Configs/Navegacao.ts
 *   3. Conferir que nao sobrou nenhuma referencia:
 *        grep -rn "OSAntigaLegado\|OS-LEGADO-CONGELADO" src/
 *   Nada fora desta pasta depende dela, entao a remocao e segura.
 * ========================================================================== */

import styled from "styled-components"

export const LoadingContainer = styled.div`
    width: 100%;
    padding: 15px 0px;
    display: flex;
    align-items: center;

    :is([data-iswhite = true]) {
        filter: brightness(0) saturate(100%) invert(100%) sepia(1%) saturate(7476%) hue-rotate(232deg) brightness(97%) contrast(98%);
    }

    div.LoadingContainer__conteudo {
        max-width: 500px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;

        span.LoadingContainer__conteudo__legenda {
            font-weight: 600;
            color: var(--primary-color);
            display: flex;
            animation: blink 0.8s infinite;
            animation-timing-function: linear;
        }

        @keyframes blink {
            0% { opacity: 1; }
            50% { opacity: 0.4; }
            100% { opacity: 1; }
        }

    }
`